import type { Rewards } from '@morpho-org/dapp-core'

import { isDefined } from '@morpho-org/morpho-ts'

export interface NetRateOnMarketArgs {
  rewards?: Rewards[] | null
  nativeRate?: bigint | null
}

/**
 * Calculates the net rate on a market (reverse calculation).
 * Net Rate = Native Rate + rewards
 *
 * @param {Rewards[] | null | undefined} [args.rewards] - An array of rewards.
 * @param {bigint | null | undefined} [args.nativeRate] - The native rate value.
 * @returns {bigint | null | undefined} - The calculated net rate, or null if the native rate is not defined.
 */
export const getNetRateOnMarket = ({ rewards, nativeRate }: NetRateOnMarketArgs) => {
  if (!isDefined(nativeRate)) return nativeRate

  const rewardsSum =
    rewards?.reduce((acc, reward) => {
      return acc + (reward.apr ?? 0n)
    }, 0n) ?? 0n

  return nativeRate + rewardsSum
}
